/* global CKEDITOR */
export default function emailVariablesCkeditorPlugin(gettext) {
  CKEDITOR.plugins.add('emailVariables', {
    icons: 'emailVariables',
    init: (editor) => {
      editor.ui.addRichCombo('emailVariables', {
        label: gettext.getString('Template variables'),
        toolbar: 'insert',
        panel: {
          css: [CKEDITOR.skin.getPath('editor')],
          multiSelect: false,
        },
        init() {
          editor.config.emailVariables.forEach((el) => {
            this.add(el, el);
          });
          this.commit();
        },
        onClick(value) {
          const attr = editor.document.createElement('span');
          attr.setText(value);
          editor.insertElement(attr);
        },
      });
    },
  });
}



// WEBPACK FOOTER //
// ./src/modules/utils/editor/email-variables-ckeditor-plugin.js